import { default as utils } from "./../utils.min.js";

function switchContent($navItem, service) {
	const $solutionTabs = $(".js-ft-solution .solution-lists li > a");
	const $solutionItems = $(".js-ft-solution .switch-items");

	// remove active
	$solutionTabs.parent("li").removeClass("active");

	// set active
	$navItem.parent("li").addClass("active");

	// Add Params to URL
	const url = new URL(window.location.href);
	url.searchParams.set("service", service);
	window.history.pushState(null, null, url);

	// Remove highlighted class in all items
	$solutionItems.find(".switch-item").removeClass("active");

	// Highlight all items based selected service
	$solutionItems.find(`.item-${service}`).addClass("active");

	// Tracking: Add the service name
	const trackableOrigName = $solutionItems.parents(".focus-area-details").data("trackable-name");
	$solutionItems.parents(".focus-area-details").attr("data-trackable-section", `${trackableOrigName}-${service}`);
}

function openContactSidebar( sidebarid ){
	const $sidebar = $("#sidebar_contact");

	$sidebar.find(".panel-details").addClass("hidden");
	$(".contact-form-container").addClass("hidden");

	$sidebar.find(".contact-form-section").removeClass("hidden");
	$sidebar.find(".contact-success-section").addClass("hidden");
	$sidebar.find(".contact-error-section").addClass("hidden");
	
	let $selectedPanel = $("#contactpanel-" + sidebarid);
	$selectedPanel.removeClass("hidden");

	let showForm = $selectedPanel.data("showform");
	if( showForm ){
		$(".contact-form-container").removeClass("hidden");
		let $contactForm = $("form[name=ft_locations_contact_form]");
		$("#contactFormTitle").text( $selectedPanel.data("title") );
		$("#contactFormDescription").text( $selectedPanel.data("description") );
		$contactForm.find("textarea[name=message]").val( $selectedPanel.data("demoformtext") );
		$contactForm.find("input[name=blinkCode]").val( $selectedPanel.data("blinkcode") );
	}

	$sidebar.addClass("show");
	$(".ft-bg-overlay").addClass("show");
	$("body").addClass("overflow-hidden");
}

$(function () {
	// get UrlParams 'service' and select
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get("service") !== null) {
		const serviceVal = urlParams.get("service");
		const $tabItem = $(`.js-ft-solution .solution-lists li > a.switch-${serviceVal}`);

		switchContent($tabItem, serviceVal);
	}

	// Highlight Contents
	$(".js-ft-solution").on("click", ".solution-lists li > a", function (e) {
		e.preventDefault();

		const $this = $(this);

		let service = $this.attr("href");
		service = service.replace("#", "");

		switchContent($this, service);
	});

	// Show - Right Panel
	$("body").on("click", ".service-items li > a.action-link:not(.link)", function (e) {
		e.preventDefault();
		const $this = $(this);
		const sidebarid = $this.data("sidebarid");
		openContactSidebar( sidebarid );
		$this.addClass("active");
	});

	// Hide - Right Panel
	$("body").on("click", ".ft-bg-overlay, .solution-panel > .btn-close", function (e) {
		e.preventDefault();

		// Remove active class in all items
		$(".js-ft-solution .solution-items li > a.item").removeClass("active");

		// Hide right panel detail
		$("#sidebar_contact").removeClass("show");
		$(".ft-bg-overlay").removeClass("show");
		$("body").removeClass("overflow-hidden");

		$("form[name=ft_locations_contact_form]").trigger("reset");
	});
});
